import React from 'react';
import Ratings from "./Ratings";

const RatingsWithMinimum = props => {
  const {
    ratings,
    ratings: {
      numRatings
    },
    onClick,
    showRatingCount
  } = props;
  if (numRatings < 3) return null;
  return /*#__PURE__*/React.createElement(Ratings, {
    onClick: onClick,
    ratings: ratings,
    showRatingCount: showRatingCount
  });
};

RatingsWithMinimum.defaultProps = {
  showRatingCount: true
};
export default RatingsWithMinimum;